import React from "react"

import { ProductPositionForm } from "widgets/product-position/product-position-form/ProductPositionForm"
import { useProductPositionFormCoreContext } from "widgets/product-position/product-position-form/contexts/ProductPositionFormCoreContext"
import { ProductPositionFormGeneralTab } from "widgets/product-position/product-position-form/ui/ProductPositionFormGeneralTab"

import { ProductPositionSidebarImage } from "./ProductPositionSidebarImage"
import { ProductPositionSidebarVariantKeyDisplay } from "./ProductPositionSidebarVariantKeyDisplay"

export const ProductPositionSidebarGeneralTab = React.memo(() => {
  const { isReadonly, formOptions } = useProductPositionFormCoreContext()

  if (!isReadonly) {
    return <ProductPositionFormGeneralTab />
  }

  return (
    <div className="product-position-sidebar__general-tab">
      <ProductPositionSidebarImage />
      <div className="product-position-sidebar__card-row">
        {formOptions?.hideQuantity ? null : (
          <div className="card card--elevated-emphasis">
            <ProductPositionForm.QuantityInput />
          </div>
        )}
        <div className="card card--elevated-emphasis">
          <ProductPositionForm.PriceInput />
        </div>
        {formOptions?.hidePriceTotal ? null : (
          <div className="card card--elevated-emphasis">
            <ProductPositionForm.TotalPrice />
          </div>
        )}
      </div>
      <div className="product-position-sidebar__row">
        <ProductPositionForm.PriceGroupInput />
        <ProductPositionForm.IsAlternativeInput />
      </div>
      <div className="product-position-sidebar__row">
        <ProductPositionForm.DisplayPositionInput />
      </div>
      <ProductPositionForm.ConfigurationButtons />
      <div className="divider" />
      <ProductPositionSidebarVariantKeyDisplay />
    </div>
  )
})
